export const SET_FEED_INITIALIZED = 'feed/SET_FEED_INITIALIZED';
export const SET_FEED_LIVE = 'feed/SET_FEED_LIVE';
export const SET_REQUESTS = 'feed/SET_REQUESTS';
export const SET_UNITS = 'feed/SET_UNITS';
export const ADD_OR_UPDATE_REQUESTS = 'feed/ADD_OR_UPDATE_REQUESTS';
export const SET_FILTER_OPTIONS = 'feed/SET_FILTER_OPTIONS';
export const SET_FILTER_SELECTIONS = 'feed/SET_FILTER_SELECTIONS';
export const SET_FILTER_SEARCH_TEXT = 'feed/SET_FILTER_SEARCH_TEXT';
export const SET_REFRESH_FULL_FEED = 'feed/SET_REFRESH_FULL_FEED';
export const SET_EXPORT_CSV_REQUESTS = 'feed/SET_EXPORT_CSV_REQUESTS';
export const SET_PRINT_REQUESTS = 'feed/SET_PRINT_REQUESTS';
export const UPDATE_REQUESTS = 'feed/UPDATE_REQUESTS';
export const SET_FILTER_PAGE_NUMBER = 'feed/SET_FILTER_PAGE_NUMBER';